// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1Tw-P","footer":"Form_footer__1ZwrT"};